export const SOCIAL_LINK_DISCORD = 'https://discord.gg/2KJ4PAqfwn';

export const LEAVE_FEEDBACK_LINK =
  'https://airtable.com/embed/appF3McmMmw1X3BAQ/shrDauuKpDtC03rGQ?backgroundColor=orange';
